export default __webpack_public_path__ + "7efc3cd97c8790581dced92ffb38a4e1.png";